import { useEffect } from "react";

/** Same right-click and shortcut blocking as the PHP rules and thank-you pages. */
export function useBlockInspect() {
  useEffect(() => {
    const onContext = (event) => event.preventDefault();
    const onKey = (event) => {
      if (event.keyCode === 123) {
        event.preventDefault();
        return;
      }
      if (event.ctrlKey && event.shiftKey && (event.keyCode === 73 || event.keyCode === 74)) {
        event.preventDefault();
        return;
      }
      if (event.ctrlKey && event.keyCode === 85) {
        event.preventDefault();
      }
    };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("keydown", onKey);
    };
  }, []);
}
